import React, { useEffect, useState,useCallback } from 'react';
import API from '../services/api';
import { useNavigate } from 'react-router-dom';
import '../styles/DebtList.css';


export default function DebtList() {
  const [debts, setDebts] = useState([]);
  const [total, setTotal] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const fetchDebts = useCallback(async () => {
    try{
    const res = await API.get('/debts');
    console.log(res.data)
    setDebts(res.data);
    }catch(err){
    console.log(err)
    navigate('/login')
    }

  },[navigate]);

  const fetchTotal = async () => {
    const res = await API.get('/debts/total');
    setTotal(res.data.total);
  };

  const markAsPaid = async id => {
    await API.put(`/debts/${id}/pay`);
    fetchDebts();
    fetchTotal();
  };

  useEffect(() => {
    fetchDebts();
    // fetchTotal();
  }, [fetchDebts]);

  const filteredDebts = debts
  .filter(d => 
    d.is_paid === 0 &&
    d.debtor_name.toLowerCase().includes(searchTerm.toLowerCase()))
  .sort((a, b) => b.date.localeCompare(a.date));

const visibleTotal = filteredDebts.reduce((sum, d) => sum + parseInt(d.amount), 0);


    return (
      <div className="debt-container">
        {/* <p className="debt-total">Total Hutang: Rp{parseInt(total || 0).toLocaleString('id-ID')}</p> */}
        <p className="debt-total">
  Total Hutang: Rp{visibleTotal.toLocaleString('id-ID')}
</p>

        <div className="search-wrapper">
        <input
          type="text"
          placeholder="Cari berdasarkan nama..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="debt-search"
        />
    </div>
        <ul className="debt-list">
          {filteredDebts.length === 0 && <li>Tidak ada hutang yang belum lunas.</li>}
          {filteredDebts.map(d => (
            <li key={d.id} className="debt-item">
              <strong>{d.debtor_name}</strong> - Rp{parseInt(d.amount).toLocaleString('id-ID')}<br />
              <small>Tanggal Hutang: {new Date(d.date).toLocaleDateString('id-ID')}</small><br />
              <span className="debt-status">❌ Belum Lunas</span><br />
              <button onClick={() => markAsPaid(d.id)} className="debt-button">
                Tandai Lunas
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
    
}
